"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FixedBottom = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
/**
 * viewport 하단 고정만 담당하는 레이아웃 primitive.
 * 높이, 간격, 배경과 내부 배치는 사용처에서 결정한다.
 */
let FixedBottom = class FixedBottom extends lit_1.LitElement {
    render() {
        return (0, lit_1.html) `
      <slot></slot>
    `;
    }
};
FixedBottom.styles = (0, lit_1.css) `
    :host {
      display: block;
      width: 100%;
      padding-bottom: env(safe-area-inset-bottom);
      box-sizing: border-box;
      position: fixed;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: var(--material-zindex-chrome);
    }
  `;
FixedBottom = __decorate([
    (0, decorators_js_1.customElement)('mm-fixed-bottom')
], FixedBottom);
exports.FixedBottom = FixedBottom;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZml4ZWQtYm90dG9tLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiZml4ZWQtYm90dG9tLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLDZCQUEyQztBQUMzQyxxREFBaUQ7QUFFakQ7OztHQUdHO0FBRUksSUFBTSxXQUFXLEdBQWpCLE1BQU0sV0FBWSxTQUFRLGdCQUFVO0lBZXpDLE1BQU07UUFDSixPQUFPLElBQUEsVUFBSSxFQUFBOztLQUVWLENBQUE7SUFDSCxDQUFDOztBQWxCTSxrQkFBTSxHQUFHLElBQUEsU0FBRyxFQUFBOzs7Ozs7Ozs7Ozs7R0FZbEIsQ0FBQTtBQWJVLFdBQVc7SUFEdkIsSUFBQSw2QkFBYSxFQUFDLGlCQUFpQixDQUFDO0dBQ3BCLFdBQVcsQ0FvQnZCO0FBcEJZLGtDQUFXIn0=